import React from "react";
const KS10Notes = () => {
  return (
    <div className="row">
      <div className="container">
        <div className=" ks10-whitebgbox">
          <div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-6 fontsize-16">
                <h4 className="">
                  <strong>Use this form if:</strong>
                </h4>
                <ul className="pl-3 mb-1">
                  <li className="pl-2">if you are a new employee who wants to opt out of KiwiSaver </li>
                  <li className="pl-2">if you were incorrectly enrolled in KiwiSaver under 18 years of age </li>
                </ul>
                <p className="mb-1">You can opt out on or after day 14 and on or before day 56 of starting new employment.</p>
                <p className="mb-1">You can’t opt out in the first 13 days.</p>
                <p className="mb-1">Every time you start new employment, you’ll need to opt out again.</p>

                <div className="clr" />
                <h4 className="mt-3">
                  <strong>Complete the form then, either:</strong>
                </h4>
                <ul className="pl-3 mb-1">
                  <li className="pl-2">give this form to your employer so they can stop deductions immediately (for prompt return of your contributions, your employer can direct refund any KiwiSaver deductions they haven’t sent to us), or </li>
                  <li className="pl-2">send this form to Inland Revenue—see address below. </li>
                </ul>

                <p className="mt-3 mb-1">If you were under 18 and enrolled in KiwiSaver without the consent of a parent or legal guardian, you may be able to opt out:</p>
                <ul className="pl-3">
                  <li className="pl-2">with the consent of a legal guardian if you’re under 16</li>
                  <li className="pl-2">without the consent of a legal guardian if you’re between 16 and 18.</li>
                </ul>

                <p>Send your completed form confirming the reason you’re opting out (Section C), and your parent or legal guardian’s written consent (if required) to Inland Revenue at the address below.</p>

                <div className="clr" />

                <h4 className="pt-3">
                  <strong>Late opt-out request</strong>
                </h4>
                <p className="mb-2">We may accept late opt-out applications if: </p>
                <ul className="pl-3 mb-1">
                  <li className="pl-2">your employer didn’t give you a KiwiSaver information pack within seven days of starting employment</li>
                  <li className="pl-2">we didn’t send you an investment statement when we’ve allocated you to a default scheme</li>
                  <li className="pl-2">your employer didn’t give you an investment statement (for their chosen KiwiSaver scheme)</li>
                  <li className="pl-2">events outside your control meant you couldn’t give us your opt-out application within the eight-week time limit</li>
                  <li className="pl-2">you chose to opt in or were opted in to KiwiSaver but you did not meet the criteria to (see Employee information pack (KS3) for criteria)</li>
                  <li className="pl-2">you were incorrectly enrolled under the age of 18.</li>
                </ul>
                <p className="mt-3">
                  <strong>Note:</strong> Give this form to your employer, or send it directly to Inland Revenue, if you are making a late opt-out application. Your request can only be considered if it’s received by Inland Revenue or your employer
                  within three months from the day Inland Revenue receives your first contribution. We will advise you if your opt-out request has been accepted or declined.
                </p>

                <h4 className="pt-3">
                  <strong>Minors incorrectly enrolled</strong>
                </h4>
                <ul className="pl-3 mb-1">
                  <li className="pl-2">enrolled before your 18th birthday without the necessary guardians/parents consent</li>
                  <li className="pl-2">Have not reached your 19th birthday</li>
                </ul>
              </div>

              <div className="col-sm-12 col-md-12 col-lg-6 fontsize-16">
                <ul className="pl-3 mb-1">
                  <li className="pl-2">under 16 years old will need the consent from a parent or legal guardian to opt out</li>
                  <li className="pl-2">complete the panel at the bottom of the form with reasons why you can opt out and attach consent from parent or legal guardian if you are under 16.</li>
                </ul>
                <p className="mb-1">We will send confirmation as to whether your opt out has been approved or not. </p>
                <p className="mb-1">We will also advise your employer. If approved your employer will stop deductions.</p>
                <p className="mb-1">Either Inland Revenue or your employer will refund any deductions that have been made.</p>

                <h4 className="pt-3">
                  <strong>Bank account details</strong>
                </h4>
                <p className="mb-1">We need your bank account details so we can direct credit any KiwiSaver funds we are holding for you to your bank account. If you don’t have these details, send the form to us anyway.</p>
                <p className="mb-1">
                  You’ll find more information in your Employee information pack (KS3) or by going to{" "}
                  <a href="https://www.ird.govt.nz/kiwisaver" target="_blank">
                    <strong>www.kiwisaver.govt.nz</strong>
                  </a>
                </p>

                <h4 className="pt-3">
                  <strong>Privacy</strong>
                </h4>
                <p>Meeting your tax obligations means giving us accurate information so we can assess your liabilities or your entitlements under the Acts we administer. We may charge penalties if you don’t.</p>

                <p className="mb-1">We may also exchange information about you with: </p>
                <ul className="pl-3 mb-3">
                  <li className="pl-2">some government agencies</li>
                  <li className="pl-2">another country, if we have an information supply agreement with them</li>
                  <li className="pl-2">Statistics New Zealand (for statistical purposes only).</li>
                </ul>
                <p>
                  If you ask to see the personal information we hold about you, we’ll show you and correct any errors, unless we have a lawful reason not to. Call us on 0800 549 472 for more information. For full details of our privacy policy go to
                  <a href="https://www.ird.govt.nz/kiwisaver" target="_blank">
                    <strong>www.ird.govt.nz</strong>
                  </a>{" "}
                  (keyword: privacy).
                </p>

                <h4 className="pt-3">
                  <strong>What an employer should do with this completed form</strong>
                </h4>
                <p>
                  Send this form to Inland Revenue no later than the next time you’re required to send an Employment information (IR348) to Inland Revenue at the address below, or you can send the information electronically in your Payroll returns
                  account in myIR. Go to{" "}
                  <a href="https://www.ird.govt.nz/myir" target="_blank">
                    <strong>www.ird.govt.nz/myIR</strong>
                  </a>{" "}
                  to register.
                </p>

                <p className="mb-1">
                  <strong>Send this completed form to:</strong>
                </p>
                <p className="mb-0">
                  <strong>Inland Revenue </strong>
                </p>
                <p className="mb-0">
                  <strong>PO Box 39090 </strong>
                </p>
                <p className="mb-0">
                  <strong>Wellington Mail Centre </strong>
                </p>
                <p>
                  <strong>Lower Hutt 5045 </strong>
                </p>

                <p>
                  For more information about KiwiSaver go to{" "}
                  <a href="https://www.ird.govt.nz/kiwisaver" target="_blank">
                    <strong>www.kiwisaver.govt.nz</strong>
                  </a>{" "}
                  or call us on 0800 549 472.
                </p>
              </div>
            </div>
          </div>
          {/* <!--Information end--> */}
        </div>
      </div>
    </div>
  );
};

export default KS10Notes;
